import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {

    loading: false,
    title: '',
    permissionItem: [],
    typeId: window.location.port || 80,
    userInfo: {
      userId: '',
      userName: '',
    },
    categoryData: [],
    pages: {}
  },
  getters: {
    //时间戳转日期
    unixTime: (state) => (t) => {
      const reg = /[\u4e00-\u9fa5]/g;
      const time = new Date(parseInt(t) * 1000).toLocaleString();
      return time.replace(reg, ' ').replace(/:\d{1,2}$/, ' ');
    },
  },
  actions: {
    setUserInfo(context, userInfo) {
      Object.freeze(userInfo)
      context.commit('setUserInfo', userInfo)
    },
    setTitle(context, title) {
      context.commit('setTitle', title)
    },
    setTypeId(context, typeId) {
      context.commit('setTypeId', typeId)
    },
    setPermissionItem(context, permissionItem) {
      Object.freeze(permissionItem)
      context.commit('setPermissionItem', permissionItem)
    },
    setCategoryData(context, categoryData) {
      context.commit('setCategoryData', categoryData)
    },
    setPages(context, pages) {
      context.commit('setPages', pages)
    }
  },
  modules: {},
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setTitle(state, title) {
      state.title = title
    },
    setTypeId(state, typeId) {
      state.typeId = typeId
    },
    setPermissionItem(state, permissionItem) {
      state.permissionItem = permissionItem
    },
    setCategoryData(state, categoryData) {
      state.categoryData = categoryData
    },
    setPages(state, pages) {
      state.pages = pages
    }
  }
})

export default store
